import svgPanZoom from 'svg-pan-zoom';
import Hammer from 'hammerjs';

const eventsHandler = {
  haltEventListeners: [
    'touchstart',
    'touchend',
    'touchmove',
    'touchleave',
    'touchcancel',
  ],
  init(options) {
    const { instance } = options;
    let initialScale = 1;
    let pannedX = 0;
    let pannedY = 0;

    // Listen only for pointer and touch events
    this.hammer = Hammer(options.svgElement, {
      inputClass: Hammer.SUPPORT_POINTER_EVENTS
        ? Hammer.PointerEventInput
        : Hammer.TouchInput,
    });
    // Enable pinch
    this.hammer.get('pinch').set({ enable: true });
    // Handle double tap
    this.hammer.on('doubletap', () => {
      instance.zoomIn();
    });
    // Handle pan
    this.hammer.on('panstart panmove', (ev) => {
      // On pan start reset panned variables
      if (ev.type === 'panstart') {
        pannedX = 0;
        pannedY = 0;
      }
      // Pan only the difference
      instance.panBy({ x: ev.deltaX - pannedX, y: ev.deltaY - pannedY });
      pannedX = ev.deltaX;
      pannedY = ev.deltaY;
    });
    // Handle pinch
    this.hammer.on('pinchstart pinchmove', (ev) => {
      // On pinch start remember initial zoom
      if (ev.type === 'pinchstart') {
        initialScale = instance.getZoom();
        instance.zoom(initialScale * ev.scale);
      }
      instance.zoom(initialScale * ev.scale);
    });
    // Prevent moving the page on some devices when panning over SVG
    options.svgElement.addEventListener('touchmove', (e) => {
      e.preventDefault();
    });
  },
  destroy() {
    this.hammer.destroy();
  },
};

export default (el) => {
  window.zoomVenue = svgPanZoom(el, {
    zoomEnabled: true,
    controlIconsEnabled: true,
    fit: true,
    center: true,
    maxZoom: 5,
    preventMouseEventsDefault: false,
    customEventsHandler: eventsHandler,
  });
};
